var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.currentSetting ? _c('div', {
    staticClass: "mod"
  }, [_c('div', {
    staticClass: "shake_egg",
    style: {
      backgroundImage: "url(".concat(_vm.currentSetting.图片, ")")
    },
    on: {
      "click": function click($event) {
        return _vm.openUrl(_vm.currentSetting.链接);
      }
    }
  })]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };